import { useEffect, useState } from "react";
import { fetchEmployeeTypes, downloadEmployeeTypesExcel } from "../Api/ViewEmployeeType";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewEmployeeType = () => {
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchEmployeeTypes();
        setEmployeeTypes(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Employee Types");
      }
    };

    loadData();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadEmployeeTypesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Employee_Types_Master_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Employee Types data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    
      <div className="main-content expand">
        <Container fluid className="list-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="list-title">View Employee Type Master</span>
            <Button className="generate-btn"
              variant="primary" 
              onClick={handleDownload}
              disabled={isDownloading || employeeTypes.length === 0}
            >
              {isDownloading ? 'Downloading...' : 'Download Data'}
            </Button>
          </div>

          {employeeTypes.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Code</th>
                      <th>Description</th>
                      <th>Created On Date</th>
                      <th>Created On Time</th>
                      <th>Created By</th>
                      <th>Changed On Date</th>
                      <th>Changed On Time</th>
                      <th>Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeTypes.map((type, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{type.code}</td>
                        <td>{type.description}</td>
                        <td>{type.createdOnDate ? moment(type.createdOnDate).format("L") : "-"}</td>
                        <td>{type.createdOnTime ? moment(type.createdOnTime, "HH:mm:ss").format("LTS") : "-"}</td>
                        <td>{type.createdBy || "-"}</td>
                        <td>{type.changedOnDate ? moment(type.changedOnDate).format("L") : "-"}</td>
                        <td>{type.changedOnTime ? moment(type.changedOnTime, "HH:mm:ss").format("LTS") : "-"}</td>
                        <td>{type.changedBy || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No Employee Types found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewEmployeeType;